import { lessonEntitySchema } from '@server/domains/lesson/entities'
import z from 'zod'

export const lessonDetailByLevelResponseSchema = z.object({
  levelName: z.string(),
  courses: z.array(lessonEntitySchema),
})
